/**
 * Mobile Menu Fix - Final Version
 * Problema: Los summary elements con clase 'link' intentan navegar en lugar de abrir submenús
 */

(function() {
  'use strict';

  // Desktop: child items with grandchildren — click text navigates, click caret toggles
  function initDesktopSubMenuLinks() {
    const selectors = [
      '.mega-menu__grandchildren-toggle > summary[data-url]',
      'details[id^="Details-HeaderSubMenu"] > summary[data-url]'
    ];
    document.querySelectorAll(selectors.join(',')).forEach(function(summary) {
      summary.addEventListener('click', function(e) {
        var caret = summary.querySelector('.icon-caret');
        if (caret && (e.target === caret || caret.contains(e.target))) return;
        e.preventDefault();
        window.location.href = summary.dataset.url;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDesktopSubMenuLinks);
  } else {
    initDesktopSubMenuLinks();
  }

  console.log('Mobile Menu Fix FINAL - Loading...');
  
  function initMobileMenuFix() {
    // Esperar a que el HeaderDrawer custom element esté inicializado
    setTimeout(() => {
      const headerDrawer = document.querySelector('header-drawer');
      if (!headerDrawer) {
        console.warn('Header drawer not found');
        return;
      }
      
      console.log('Header drawer found, applying mobile menu fix...');
      
      // Encontrar todos los summary que tienen submenús (menú principal)
      const summariesWithSubmenus = headerDrawer.querySelectorAll('details[id*="Details-menu-drawer-menu-item-"] > summary');
      
      summariesWithSubmenus.forEach((summary, index) => {
        const details = summary.parentNode;
        const submenu = details.querySelector('.menu-drawer__submenu');
        
        if (submenu) {
          const menuText = summary.querySelector('.menu-drawer__menu-text');
          const menuArrow = summary.querySelector('.menu-drawer__menu-arrow');
          
          if (menuText && menuArrow) {
            const menuTitle = menuText.textContent.trim();
            const menuUrl = menuText.getAttribute('data-url');
            console.log(`Setting up menu: ${menuTitle} - URL: ${menuUrl}`);
            
            // Solo interceptar clicks en el texto del menú (navegar a la página)
            menuText.addEventListener('click', function(e) {
              console.log(`Text clicked for: ${menuTitle} - navigating to: ${menuUrl}`);
              
              e.preventDefault();
              e.stopPropagation();
              
              // Navegar a la URL
              if (menuUrl) {
                window.location.href = menuUrl;
              }
            });
            
            // NO tocar la flecha - dejar que funcione completamente natural
          }
          
          // Configurar botón de volver en submenú (solo la flecha)
          const backButton = submenu.querySelector('.menu-drawer__close-button');
          if (backButton) {
            const menuTitle = summary.querySelector('.menu-drawer__menu-text')?.textContent.trim() || 'Unknown';
            backButton.addEventListener('click', function(e) {
              console.log(`Back button clicked for: ${menuTitle}`);
              
              e.preventDefault();
              e.stopImmediatePropagation();
              
              // Cerrar el submenú y volver al principal
              details.removeAttribute('open');
              summary.setAttribute('aria-expanded', 'false');
              
              console.log(`Returned to main menu from: ${menuTitle}`);
            });
          }
          
          // Configurar enlace del título del menú en submenú (navega a la URL)
          const parentLink = submenu.querySelector('.menu-drawer__parent-link');
          if (parentLink) {
            const menuTitle = summary.querySelector('.menu-drawer__menu-text')?.textContent.trim() || 'Unknown';
            console.log(`Parent link found for: ${menuTitle} - URL: ${parentLink.href}`);
            // NO agregar preventDefault aquí - debe navegar a la URL
            parentLink.addEventListener('click', function(e) {
              console.log(`Navigating to URL for: ${menuTitle} - ${parentLink.href}`);
              // Permitir navegación normal
            });
          }
        }
      });
      
      console.log(`Mobile menu fix applied to ${summariesWithSubmenus.length} main menu items`);

      // Nested submenus: child items that have grandchildren
      const nestedSummaries = headerDrawer.querySelectorAll('details[id*="Details-menu-drawer-"]:not([id*="menu-item"]) > summary');

      nestedSummaries.forEach((summary) => {
        const details = summary.parentNode;
        const menuText = summary.querySelector('.menu-drawer__menu-text');

        if (menuText) {
          const menuUrl = menuText.getAttribute('data-url');
          menuText.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            if (menuUrl) {
              window.location.href = menuUrl;
            }
          });
        }

        // Back button inside nested submenu
        const submenu = details.querySelector('.menu-drawer__submenu');
        if (submenu) {
          const backButton = submenu.querySelector('.menu-drawer__back-button');
          if (backButton) {
            backButton.addEventListener('click', function(e) {
              e.preventDefault();
              e.stopImmediatePropagation();
              details.removeAttribute('open');
            });
          }
        }
      });

      console.log(`Mobile menu fix applied to ${nestedSummaries.length} nested menu items`);
      
    }, 2000); // Delay más largo para asegurar inicialización completa
  }
  
  // Ejecutar cuando el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileMenuFix);
  } else {
    initMobileMenuFix();
  }
  
  // También ejecutar cuando la ventana cambie de tamaño
  window.addEventListener('resize', () => {
    if (window.innerWidth <= 989) {
      setTimeout(initMobileMenuFix, 500);
    }
  });
  
})();
